export default "__VITE_ASSET__DsJN5NDt__"